import Router from "./Router/Router";
import { Toaster } from "react-hot-toast";
import { useUser } from "./context/UserContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ConfirmProvider } from "material-ui-confirm";

export const WebsiteName = "TRADEFOLIO";

function App() {
  const user = useUser();

  return (
    <DndProvider backend={HTML5Backend}>
      <ConfirmProvider>
        <Router />
        <Toaster />
      </ConfirmProvider>
    </DndProvider>
  );
}

export default App;
